import { ILoadingCellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, ILoadingCellRendererParams } from 'ag-grid-community';

import { Component } from '@angular/core';

@Component({
    selector: 'al-load-row-cell-renderer',
    imports: [],
    templateUrl: 'loading-row-cell-renderer.component.html',
    styleUrl: 'loading-row-cell-renderer.component.scss'
})
export class LoadingRowCellRendererComponent implements ILoadingCellRendererAngularComp {
  public nbPeriodCols = 0;
  public groupColWith = 0;

  public agInit(params: ILoadingCellRendererParams): void {
    this.nbPeriodCols = params.api.getColumnDefs()?.filter((col: ColDef) => !col.hide).length ?? 0;
    const groupCol = params.api.getLeftDisplayedColumnGroups().at(0);
    this.groupColWith = groupCol?.getActualWidth() ?? 0;
  }
}
